import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { useStore } from '../../../../store';
import { useActions } from '../../../providers/actions-provider/actions.context';
import './rules-pseudo-code.less';

type RulesPseudoCodeProps = {
  reload: boolean,
};

const RulesPseudoCode = ({ reload }: RulesPseudoCodeProps): JSX.Element => {
  const {
    rulesPseudocode,
  } = useStore();
  const { tenantActions } = useActions();

  useEffect(() => {
    async function doGet() {
      await tenantActions.getRulesPseudocode();
    }

    doGet();
  }, [reload]);

  if (rulesPseudocode.loading) {
    return (
      <div style={{ width: '100%', textAlign: 'center' }}><Spin /></div>
    );
  }

  const { data } = rulesPseudocode;
  return (
    <div className="pseudocode-container">
      <pre className="pseudocode">
        {data}
      </pre>
    </div>
  );
};
export default RulesPseudoCode;
